import React from 'react';
import PropTypes from 'prop-types';

const Shopping = ({ size, color }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.799 4.25506C1.97873 4.25506 1.29249 4.86815 1.21312 5.6719L0.678429 11.0862C0.541856 12.4692 1.64587 13.6668 3.05725 13.6668H8.9434C10.3548 13.6668 11.4588 12.4692 11.3222 11.0862L10.7875 5.6719C10.7082 4.86815 10.0219 4.25506 9.20165 4.25506H2.799ZM5.20364 6.608C5.20364 6.17484 4.84696 5.82369 4.40696 5.82369C3.96697 5.82369 3.61029 6.17484 3.61029 6.608V7.39231C3.61029 8.69181 4.68034 9.74525 6.00032 9.74525C7.3203 9.74525 8.39035 8.69181 8.39035 7.39231V6.608C8.39035 6.17484 8.03367 5.82369 7.59368 5.82369C7.15368 5.82369 6.797 6.17484 6.797 6.608V7.39231C6.797 7.82548 6.44031 8.17663 6.00032 8.17663C5.56033 8.17663 5.20364 7.82548 5.20364 7.39231V6.608Z"
      fill={color}
    />
    <path
      d="M6.80602 3.47075V2.69527C6.80602 2.25723 6.44531 1.90212 6.00037 1.90212C5.55542 1.90212 5.19472 2.25723 5.19472 2.69527V3.47075H3.60136V2.69527C3.60136 1.3909 4.67543 0.333496 6.00037 0.333496C7.3253 0.333496 8.39937 1.3909 8.39937 2.69527V3.47075H6.80602Z"
      fill={color}
    />
  </svg>

);

Shopping.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

Shopping.defaultProps = {
  color: '#2196F3',
  size: 12,
};

export default Shopping;
